<template>
    <div class="container">
          <div v-for="(block, index) in blocks" :key="block.blockId" v-appear.toggle v-html="block.html" class="sd-block-wrapper" v-resize:debounce="resizeVideoIframes"></div>
    </div>
</template>

<script>
import axios from 'axios';

import VueAppear from 'vue-appear';
 
Vue.use(VueAppear);

import resize from 'vue-resize-directive';

    export default {
        mounted() {
            this.getBlocks();
        },
        directives: {
          resize,
        },
        props: [
            'id',
            'contact',
        ],        
        data: function(){
            return {
                deckId: this.id,
                contactId: this.contact,
                deckDefaults: [],            
                blocks:[],
                }
        },
        methods: {
            getBlocks: function(){

              const url = `/deck/output/`+ this.deckId +`/blocks/`+this.contactId;

              var vm = this;

              axios.get(url).then(response => {

                if(response.data.length > 0){                

                response.data.forEach(function(block){

                  // Insert content
                  var blockHtml = $('<div></div>').append(block.block_template.html); // Create a holder div for jQuery to work from.

                  block.content = JSON.parse(block.content);

                  
                  block.content.forEach(function(item, index){
                    if(item.type == 'singleline' || item.type == 'multiline' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').html(item.content);
                    }
                    if(item.type == 'image'){
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                      if(typeof item.link !== 'undefined' && item.link !== null){ // if has link then set
                        blockHtml.find('[data-reference="' + item.reference + '"]').wrap('<a href="'+item.link+'" target="blank"></a>');
                      }
                    }
                    if(item.type == 'avatar' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }
                    if(item.type == 'video' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }
                    if(item.type == 'background' ){
                      blockHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.color);

                      if(item.image){
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('background-image',"url('"+item.image+"')"); // Update the color
                      }else{
                        blockHtml.find('[data-reference="' + item.reference + '"]').css('background-image',''); // Update the color
                      }

                      blockHtml.find('[data-reference="' + item.reference + '"]').removeClass(function (index, css) {
                        return (css.match (/\bskin-\S+/g) || []).join(' '); // removes anything that starts with "skin-"
                      }).addClass('skin-'+item.skin);

                    }
                    if(item.type == 'button' ){

                      let fullLink = item.link;
                      if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                      if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);


                      let fullText = item.text;
                      if(typeof item.textprepend !== 'undefined'){ fullText = item.textprepend+fullText;}
                      if(typeof item.textappend !== 'undefined'){ fullText = fullText+item.textappend; }
                      blockHtml.find('[data-reference="' + item.reference + '"]').html(fullText);                      

                      blockHtml.find('[data-reference="' + item.reference + '"]').css('color',item.color);               
                      blockHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.background);     
                    }

                    if(item.type == 'link' ){

                      let fullLink = item.link;
                      if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                      if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                      blockHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);

                    }


                    if(item.type == 'showhide' ){

                      // Convert to bool
                      if(item.state === 'false'){ // Convert to bool
                        item.state = false;
                      }
                      if(item.state === 'true'){ // Convert to bool
                        item.state = true;
                      }

                      if(item.state===false){
                        blockHtml.find('[data-reference="' + item.reference + '"]').remove();
                        //blockHtml.find('[data-reference="' + item.reference + '"]').addClass('d-none');
                      }
                    }

                  });

                  vm.blocks.push({
                    blockId: block.id,
                    blockTemplateId: block.blocktemplate_id,
                    html: blockHtml.html(),
                    editable: block.block_template.editable,
                    current: block.content
                  });                 

                });

                this.$nextTick(function () {
                  vm.resizeVideoIframes();
                });


                }

              }).catch(() => console.warn('Oh. Something went wrong. getBlocks'));

          },
          resizeVideoIframes: function(){

              $('.sd-block iframe').each(function () {

                    var oW = $(this).width();
                    var oH = $(this).height();
                    var nW = $(this).parent().width();
                    
                    var nH = ( oH/oW ) * nW;

                    $(this).width(Math.round(nW));
                    $(this).height(Math.round(nH));

              });
          }
        }

    }


</script>
